import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);


const appColours = {
  primary: '#263746',
  gx_green: '#a1d0ca',
  secondary: '#a1d0ca',
  accent: '#d8d1ca',
  gx_beige: '#d8d1ca',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107',
  gx_grey: '#e4e4e4',
};

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  breakpoint: {
    thresholds: {
      xs: 340,
      sm: 540,
      md: 800,
      lg: 1100,
    },
    scrollBarWidth: 24,
  },
  theme: {
    dark: false,
    themes: {
      dark: appColours,
      light: appColours,
    }
  }
});
